module.exports = "<div toastContainer class=\"toast-top-right\"></div>\n<app-loading></app-loading>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 1086
// module chunks = 0